import styled, { css } from 'styled-components';
import { COLOURS } from '@belong/themes';
import { InlineSpinnerComponent } from '../../../feedback/LoadingSpinner/InlineSpinner';

export const StyledButtonSpinner = styled(InlineSpinnerComponent)<{
  isLightColor?: boolean;
  isInlineSpinnerLoading?: boolean;
}>`
  flex-direction: row;
  align-items: center;
  align-self: center;

  ${({ isInlineSpinnerLoading }) =>
    !isInlineSpinnerLoading &&
    css`
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      white-space: nowrap;
      pointer-events: none;
    `}

  & > div {
    width: 2.4rem;
    height: 2.4rem;
    border: 0.3rem solid;
    border-color: ${({ isLightColor, theme }) =>
        isLightColor
          ? (theme.button.primary.isLightColor?.loading?.color ?? COLOURS.BLACK)
          : (theme.button.primary.loading?.color ?? COLOURS.BELONG_BLUE)}
      ${({ isLightColor }) => (isLightColor ? 'rgb(255, 255, 255, 25%)' : 'rgb(0, 0, 0, 25%)')}
      ${({ isLightColor }) => (isLightColor ? 'rgb(255, 255, 255, 25%)' : 'rgb(0, 0, 0, 25%)')};

    &::before,
    &::after {
      width: 0.2rem;
      height: 0.2rem;
      background: ${({ isLightColor, theme }) =>
        isLightColor
          ? (theme.button.primary.isLightColor?.loading?.color ?? COLOURS.BLACK)
          : (theme.button.primary.loading?.color ?? COLOURS.BELONG_BLUE)};
    }
  }

  & > span,
  & > span > *,
  & > span > * > * {
    color: ${({ isLightColor, theme }) =>
      isLightColor
        ? (theme.button.primary.isLightColor?.loading?.color ?? COLOURS.BLACK)
        : (theme.button.primary.loading?.color ?? COLOURS.BELONG_BLUE)};
  }

  & > span * {
    color: inherit;
  }
`;
